import React from "react";
import TextCellInfo from "./TextCellInfo";
import { RuleModuleType } from "../../constants/constants";

interface Props {
  name: string;
  ruleModuleType: RuleModuleType;
  adminMode: boolean;
  dataTest: string;
}

export default function AttributeHeader({
  name,
  ruleModuleType,
  adminMode,
  dataTest,
}: Props) {
  const elements: JSX.Element[] = [];
  elements.push(
    <TextCellInfo key="type-name" dataTest={`name-${dataTest}`} text={name} />
  );
  if (
    [
      RuleModuleType.RankAndSource,
      RuleModuleType.RankOnly,
      RuleModuleType.SelectAndRank,
    ].includes(ruleModuleType)
  ) {
    elements.push(
      <TextCellInfo
        key="rank-label"
        dataTest={`rank-label-${dataTest}`}
        text="Rank"
      />
    );
  }
  if (
    ![RuleModuleType.SelectAndRank, RuleModuleType.SelectOnly].includes(
      ruleModuleType
    )
  ) {
    elements.push(
      <TextCellInfo
        key="bonus-label"
        dataTest={`bonus-label-${dataTest}`}
        text="Bonus"
      />
    );
  }
  if (adminMode) {
    elements.push(
      <TextCellInfo
        classes="grid-cell-fill"
        key="module-type"
        dataTest={`module-type-${ruleModuleType}-${dataTest}`}
        text={`${ruleModuleType}`}
      />
    );
  }

  return React.createElement(React.Fragment, {}, elements);
}
